/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const payginePaymentCallbackResponseSchema = z.object({
	order_uuid: z.uuid(),
});
